import React, { useState, useEffect, useRef } from 'react';
import './socialmedia.css';
import socialIcon from '../../assets/social_media_common.png';
import whatsappIcon from '../../assets/whatsapp_icon.png';
import threadsicon from '../../assets/threads_social_media.png';
import linkedinIcon from '../../assets/linkedin.png';
import instagramIcon from '../../assets/instragram_icon.png';

const SocialMediaIcons: React.FC = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  const toggleDropdown = () => {
    setIsDropdownOpen(prev => !prev);
  };

  useEffect(() => {
    function handleClickOutside(event: MouseEvent | TouchEvent) {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        setIsDropdownOpen(false);
      }
    }

    if (isDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('touchstart', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, [isDropdownOpen]);

  return (
    <div className="social-icons-container" ref={containerRef}>
      <div 
        className="main-icon-with-arrow"
        onClick={toggleDropdown}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') toggleDropdown();
        }}
        aria-expanded={isDropdownOpen}
        aria-haspopup="true"
      >
        <img src={socialIcon} alt="Social Media" className="social-icon_side" />
        <span className={`dropdown-arrow ${isDropdownOpen ? 'open' : ''}`}>ᐯ</span>
      </div>

      <div className={`dropdown-menu ${isDropdownOpen ? 'show' : ''}`}>
        <a href="https://wa.me/919176533933" target="_blank" rel="noopener noreferrer">
          <img src={whatsappIcon} alt="WhatsApp" className="social-icon" />
        </a>
        <a href="https://www.linkedin.com/company/intellectoglobalservices/" target="_blank" rel="noopener noreferrer">
          <img src={linkedinIcon} alt="LinkedIn" className="social-icon" />
        </a>
        <a href="https://www.instagram.com/intellecto_globalservices/" target="_blank" rel="noopener noreferrer">
          <img src={instagramIcon} alt="Instagram" className="social-icon" />
        </a>
        <a href="https://x.com/Intellecto_igs" target="_blank" rel="noopener noreferrer">
          <img src={threadsicon} alt="twitter" className="social-icon" />
        </a>
      </div>
    </div>
  );
};

export default SocialMediaIcons;
